<script>
export default {
}
</script>

<template>
  <v-flex xs12>
    <v-card>
      <iframe width="100%" src="/design-relatorio" height="500" />
    </v-card>
  </v-flex>
</template>
